<template>
  <el-dialog 
    width="420px"
    :title="dialog.title" 
    :visible.sync="dialog.isShow"
    @open='open' >
    <el-form ref="form" :model="form" label-width="80px">       
      <el-form-item label="商圈名称">          
        <el-input v-model="form.name"></el-input>        
      </el-form-item>
      <el-form-item label="商圈描述">          
        <el-input v-model="form.description"></el-input>        
      </el-form-item>
      <el-form-item label="商圈地址">
        <el-col >
          <el-input v-model="form.address" >
            <el-button slot="append" icon="el-icon-location-information" @click="ShowMap"></el-button>
          </el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="商圈图标">
        <el-col :span="12">
          <el-upload
            class="upload-demo"
            :action="uploadUrl"
            :headers="headers"
            :on-success="handleIconSuccess"
            :file-list="fileList">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-col>
      </el-form-item>  
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialog.isShow = false">取 消</el-button>
      <el-button type="primary" @click="Save">保 存</el-button>
    </div>    
    <GetCoordinate v-bind:dialogMap="dialogMap" @UpdatePostion="UpdatePostion"></GetCoordinate>
  </el-dialog> 
</template>

<script  type='text/ecmascript-6'>
import GetCoordinate from '@/components/GetCoordinate'
export default {
  props:{
    dialog:{}
  },
  data (){
    return {
      form : {},
      dialogMap:{
        isShow:false,
        oldPoint:{
          lat:0,
          lng:0
        }
      },
      fileList:[],
      uploadUrl: this.global.serverSrc+'/api/Common/UploadImage',
      headers:{
        Authorization : sessionStorage.getItem('token')
      },
    }
  },  
  components:{
    GetCoordinate  
  },
  computed:{
  },
  mounted(){
  },
  methods:{
    GetData:function(){

    },
    UpdatePostion:function(point){
      this.form.lat = point.lat
      this.form.lng = point.lng
    },
    open:function(){      
      console.log("open:"+this.dialog.id)
      var that = this
      this.axios({
        method:'post',
        url:that.global.serverSrc + '/api/BusinessCircle/Get',         
        data:{
          id: that.dialog.id
        }
      }).then(function (resp) {
        if(resp.data.errorCode==0){
          that.form = resp.data.businessCircle
          that.dialogMap.oldPoint.lat=resp.data.businessCircle.lat
          that.dialogMap.oldPoint.lng=resp.data.businessCircle.lng
        }else {
          that.$message.warning(resp.data.message);
        }  
      }).catch(resp => {         
        console.log('请求失败：' + resp.message + ',' + resp.stack)
      })
    },   
    Save(){
      var that = this
      this.axios({
        method:'post',
        url:that.global.serverSrc + '/api/BusinessCircle/Save',         
        data:this.form
      }).then(function (resp) {
        if(resp.data.errorCode==0){
          that.$message.success(resp.data.message);
          that.dialog.isShow = false
          that.$emit('GetDate')
        }else {
          that.$message.warning(resp.data.message);
        }  
      }).catch(resp => {         
        console.log('请求失败：' + resp.message + ',' + resp.stack)
      })
    },
    ShowMap:function(){
      this.dialogMap.isShow = true
    },     
    handleIconSuccess(res, file){
      this.form.image= res.fullUrl
    },
  },
  created(){
  
  },
}
</script>